import classNames from 'classnames';
import React, { ComponentProps, ReactNode } from 'react';
import { Modal } from 'rsuite';
import { ModalBodyProps } from 'rsuite/lib/Modal/ModalBody';
import { ModalFooterProps } from 'rsuite/lib/Modal/ModalFooter';
import { ModalHeaderProps } from 'rsuite/lib/Modal/ModalHeader';
import { Icon, IconProps } from '../../pages/IPA/RevisaoPrecos/Components';
import styles from './DesignSystemSpecialModal.module.scss';

export type DesignSystemSpecialModalProps = {
  className?: string;
  children?: ReactNode;
  show?: boolean;
  onHide?: () => void;
};

const ModalHeader = ({ children, className, ...props }: ModalHeaderProps) => {
  return (
    <Modal.Header className={classNames(styles.header, className)} {...props}>
      {children}
    </Modal.Header>
  );
};

const ModalIcon = ({ className, ...props }: IconProps) => {
  return <Icon className={classNames(styles.icon, className)} {...props} />;
};

const ModalBody = ({ children, className, ...props }: ModalBodyProps) => {
  return (
    <Modal.Body className={classNames(styles.body, className)} {...props}>
      {children}
    </Modal.Body>
  );
};

const ModalTitle = ({ className, children, ...props }: ComponentProps<'h6'>) => {
  return (
    <h6 className={classNames(styles.title, className)} {...props}>
      {children}
    </h6>
  );
};

const ModalBodyText = ({ className, children, ...props }: ComponentProps<'h6'>) => {
  return (
    <p className={classNames(styles.content, className)} {...props}>
      {children}
    </p>
  );
};

const ModalFooter = ({ children, className, ...props }: ModalFooterProps) => {
  return (
    <Modal.Footer className={classNames(styles.footer, className)} {...props}>
      {children}
    </Modal.Footer>
  );
};

const DesignSystemSpecialModal = ({ className, children, ...props }: DesignSystemSpecialModalProps) => {
  return (
    <Modal className={classNames(styles.modal, className)} {...props}>
      {children}
    </Modal>
  );
};

const Component = {
  Root: DesignSystemSpecialModal,
  Header: ModalHeader,
  Icon: ModalIcon,
  Body: ModalBody,
  Title: ModalTitle,
  Content: ModalBodyText,
  Footer: ModalFooter,
};

export default Component;
